module.exports = __webpack_public_path__ + "img/conected.7ca4057c.png";